import React                 from 'react';
import { arrayX as tooltip } from 'pu-data/Tooltips';
import TextComponent         from './base/TextComponent';

const ArrayX = (props) => {
  const name = 'array_x';
  const onChange = e => props.onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label="Array X Dim"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      error={props.errors.array_x} />

  );
};

ArrayX.defaultProps = {
};

export default ArrayX;
